import BaseAction from "./BaseAction";
import EnforcementReducer from "../reducers/EnforcementReducer";

class EnforcementAction extends BaseAction {
  onClose = () => {};

  open = async (data) => await this.dispatch({ ...data, open: true });

  setLoadingTypes = async (value) => this.dispatch({ loadingTypes: value });
}

const action = new EnforcementAction(EnforcementReducer);

export default action;
